export default __webpack_public_path__ + "static/media/chevron-left.bea8557a.svg";